import React from 'react';
import '../allcss/program.css';
import Hero4 from '../Asets/Hero4.jpg';
import Hero2 from '../Asets/Hero2.jpg';
import Program2 from '../Asets/Program2.jpg';
import Program4 from '../Asets/Program4.jpg';
import RedPhoto1 from '../Asets/RedPhoto1.jpeg';
import RedPhoto2 from '../Asets/RedPhoto2.jpeg';
import RedPhoto4 from '../Asets/RedPhoto4.jpeg';
import RedPhoto7 from '../Asets/Redphoto7.jpeg';
import { Helmet } from "react-helmet-async";

// AnimatedText splits string into spans with animation delay for each char
const AnimatedText = ({ text }) => {
  return (
    <>
     <Helmet>
        <link
          rel="canonical"
          href="https://www.redhouseschoolvadodara.in/program"
        />
      </Helmet>
      {[...text].map((char, i) => (
        <span
          key={i}
          className="char"
          style={{ animationDelay: `${i * 0.15}s` }}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </>
  );
};

const ActivityPrograms = () => {
  return (
    <section className="activity-programs">
      <br />
      
      <div className="container">
        <div className="content-block">
          <span className="section-subtitle">Our Activities</span>
          <h2 className="animated-heading">
            <AnimatedText text="Building Strong" /><br />
            <AnimatedText text="Foundations for" /><br />
            <AnimatedText text="Lifelong Success" />
          </h2>
        <p className="description">
  At <strong>RED School House</strong>, we nurture confident, curious, and happy learners through a Singapore-inspired, play-based curriculum. With experienced educators, personalized attention, and engaging programs from Playgroup to Day Care, we help every child develop essential skills for lifelong learning.
</p>

          
        </div>
        <div className="cards-grid">
          <div className="card card-purple">
            <div className="card-image-container">
              <img
                src={RedPhoto1}
                alt="Enrichment Activities"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <h3>Enrichment Programs & Services</h3>
              <p>Storytelling, music, art, STEM, sensory play, and creative activities inspire imagination, teamwork, confidence, and a love for learning every day.</p>
            </div>
          </div>
          <div className="card card-orange">
            <div className="card-image-container">
              <img
                src={RedPhoto2}
                alt="Kinder Prep"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <h3>Day Care</h3>
              <p>Our day care provides a safe, nurturing environment where children learn, play, and grow with caring educators, building confidence, independence, and social skills.</p>
            </div>
          </div>
          <div className="card card-red">
            <div className="card-image-container">
              <img
                src={RedPhoto4}
                alt="Little Learners"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <h3>Playgroup / Nursery</h3>
              <p>Our Playgroup and Nursery programs build language, creativity, motor skills, and social confidence through fun, interactive learning experiences.</p>
            </div>
          </div>
          <div className="card card-purple-light">
            <div className="card-image-container">
              <img
                src={RedPhoto7}
                alt="Early Explorers"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <h3>Jr Kg / Sr Kg</h3>
              <p>Our KG programs strengthen literacy, numeracy, communication, and critical thinking, preparing children for a confident start to primary school.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bunny-icon">🐰</div> {/* Placeholder for bunny icon */}
    </section>
  );
};

export default ActivityPrograms;
